// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.stack[data-v-59c14148] {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  justify-items: start;
  align-items: start;
> *[data-v-59c14148] {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
}
}
.wrapper[data-v-59c14148] {
  position: fixed;
  inset: 0;
  justify-items: end;
  align-items: end;
  pointer-events: none;
  padding: 1.5rem;
  z-index: var(--z-notifications);
}
.item[data-v-59c14148] {
  pointer-events: auto;
  background: #234;
  color: #fff;
  border-radius: 4px;
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
  max-width: 400px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 0.5rem 2rem 0rem rgba(0, 0, 0, 0.25);
  transition: all 0.3s;
  position: relative;
}
@starting-style {
.item[data-v-59c14148] {
    transform: translateY(20px);
    opacity: 0;
}
}
.progress-bar[data-v-59c14148] {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  pointer-events: none;
  background: white;
  mix-blend-mode: overlay;
  transition: width 0.1s linear;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
